import Vue from "vue";
import * as types from "./mutation-types";

const actions = {
  async inviteOutsider({ commit }, email) {
    commit(types.SET_OUTSIDER_INVITED_PROCESSING, true);

    let response = null;

    try {
      response = await Vue.axios.post(`invites`, {
        type: "outsiders",
        outsiderEmail: email
      });
    } catch (e) {
      // the only error message that would make sense for the user to see
      // would be if the outsider email was invalid, otherwise we can
      // check sentry for any other error that occurs.
      const error = e.response.data.error;
      let message = null;

      if (error.fields && error.fields.outsiderEmail) {
        message = error.fields.outsiderEmail[0];
      } else {
        message =
          "Could not send invite, please contact wellness@be-engaged.co";
      }

      response = {
        error: true,
        message: message
      };
    }

    commit(types.SET_OUTSIDER_INVITED_PROCESSING, false);

    return response;
  },

  inviteChallengeAllMembers({ dispatch }, challengeId) {
    return Vue.axios
      .post(`invites`, {
        type: "competitions",
        challengeId: challengeId,
        includeAll: 1
      })
      .then(response => {
        return response;
      })
      .catch(error => {
        dispatch(
          "snackBar",
          {
            duration: 10000,
            queue: false,
            message: error.response.data.error.message,
            type: "is-danger"
          },
          { root: true }
        );

        return false;
      });
  },

  inviteChallengeAllTeams({ dispatch }, challengeId) {
    return Vue.axios
      .post(`invites`, {
        type: "competitions",
        challengeId: challengeId,
        includeAll: 1
      })
      .then(response => {
        return response;
      })
      .catch(error => {
        dispatch(
          "snackBar",
          {
            duration: 10000,
            queue: false,
            message: error.response.data.error.message,
            type: "is-danger"
          },
          { root: true }
        );

        return false;
      });
  },

  inviteChallengeEntities({ dispatch }, payload) {
    // let { recipientIds, teamIds, challengeId } = payload
    const entityType = Vue._.has(payload, "teamIds") ? "teams" : "members";

    return Vue.axios
      .post(`invites`, {
        type: "competitions",
        ...payload
      })
      .then(response => {
        if (response && response.data.success) {
          dispatch(
            "snackBar",
            {
              duration: 10000,
              queue: false,
              type: "is-success",
              message: `Invites have been sent for selected ${entityType}.`
            },
            { root: true }
          );
        }
      })
      .catch(error => {
        dispatch(
          "snackBar",
          {
            duration: 10000,
            queue: false,
            message: error.response.data.error.message,
            type: "is-danger"
          },
          { root: true }
        );

        return false;
      });
  },

  inviteTeamMembers({ dispatch }, payload) {
    let { recipientIds, teamId } = payload;
    return Vue.axios
      .post(`invites`, {
        type: "groups",
        recipientIds,
        teamId
      })
      .then(response => {
        if (response && response.data.success) {
          dispatch(
            "snackBar",
            {
              duration: 10000,
              queue: false,
              message: "Team invites sent!",
              type: "is-success"
            },
            { root: true }
          );
          return response;
        }
      })
      .catch(error => {
        dispatch(
          "snackBar",
          {
            duration: 10000,
            queue: false,
            message: error.response.data.error.message,
            type: "is-danger"
          },
          { root: true }
        );

        return false;
      });
  }
};

export default actions;
